import React, {Component} from 'react';
import AppBar from '@mui/material/AppBar/index';
import Toolbar from '@mui/material/Toolbar/index';
import Typography from '@mui/material/Typography/index';
import {withRouter} from "react-router-dom";
import NavbarUserMenu from "./NavbarUserMenu";
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {close_navigation, open_navigation} from "../../actions/navigation";
import {Drawer, List, ListItem, ListItemText} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import Divider from "@mui/material/Divider";
import logo_dark from "../../images/logo/logo_dark.png"
import DarkModeToggle from "react-dark-mode-toggle";
import {switchMode} from "../../actions/theming";
import clsx from "clsx";
import Button from "@mui/material/Button";
import logo_v_on_black from "../../images/logo/logo_v_on_black.png"

const styles = {
    root: {
        flexGrow: 1,
        maxHeight: 48
    },
    bar_fill: {
        flexGrow: 1,
    },
    logo_v_container: {
        height: 48,
        //width: 48,
        cursor: "pointer",
    },
    logo_v: {
        height: 48,
        //width: 48,
        background: "black"
    },
    drawer_icon: {
        fontSize: "24px !important"
    },
    title: {
        textTransform: "none !important"
    },
    fullList: {
        width: 250,
    },
    toolbarButtons: {},
    leftMenu: {},
    drawer: {
        minWidth: "300px"
    },
    list: {
        padding: 0
    },
    logo: {
        width: 300,
        margin: "25px 16px"
    },
    darkModeSwitch: {
        marginRight: "10px"
    },
    enabled_black: {
        background: "black"
    },
    enabled_white: {
        background: "white"
    }
};

class Navbar extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {classes} = this.props

        let sorted_clusters;
        if (this.props.clusters) {
            sorted_clusters = [
                ...this.props.clusters.filter((c) => !c.disabled),
                ...this.props.clusters.filter((c) => c.disabled),
            ];
        }

        return <>
            <Drawer anchor={"left"} open={this.props.navigation.drawerOpen}
                    onClose={() => this.props.close_navigation()}
                    classes={{
                        paper: clsx(classes.drawer, this.props.theming.darkMode ? classes.enabled_black : classes.enabled_white)
                    }}
            >
                <img src={this.props.theming.darkMode ? logo_dark : logo_dark} alt="Logo"
                     className={classes.logo}/>
                <List className={classes.list}>
                    <ListItem button onClick={() => {
                        this.props.history.push("/clusters")
                    }}>
                        <ListItemText primary={"Clusters"}/>
                    </ListItem>

                </List>
                <List className={classes.list}>
                    <Divider/>
                    {sorted_clusters && sorted_clusters.map((cluster) => (
                        <ListItem button key={cluster.id} onClick={() => {
                            this.props.history.push("/clusters/" + cluster.id)
                        }} disabled={cluster.disabled}>
                            <ListItemText primary={cluster.title}/>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar variant="dense">
                        <Button
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={() => this.props.open_navigation()}
                            startIcon={<MenuIcon className={classes.drawer_icon}/>}
                        >
                            <Typography variant="h6" className={classes.title}>
                                {this.props.navigation.title}
                            </Typography>
                        </Button>
                        <span className={classes.bar_fill}></span>
                        <span className={classes.logo_v_container} onClick={() => {
                            this.props.history.push("/clusters")
                        }}>
                                <img src={logo_v_on_black} alt="V" className={classes.logo_v}/>
                        </span>

                        <span className={classes.bar_fill}></span>
                        <DarkModeToggle
                            className={classes.darkModeSwitch}
                            onChange={this.props.switchMode}
                            checked={this.props.theming.darkMode}
                            name="darkModeSwitch"
                            size={60}
                        />
                        <NavbarUserMenu/>
                    </Toolbar>
                </AppBar>
            </div>
        </>;
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    navigation: state.navigation,
    clusters: state.clusters.clusters,
    theming: state.theming
});

export default withStyles(styles)(withRouter(connect(
    mapStateToProps,
    {open_navigation, close_navigation, switchMode}
)(Navbar)));
